export const certificates = [
  {
    id: 1,
    title: "Hult Prize Winner - Arsi University",
    issuer: "Hult Prize Foundation",
    year: "2026",
    image: "/assets/certificates/hultprize.png",
    link: "https://www.linkedin.com/in/firatol-esayas-tefera/overlay/Certifications/1277319957/treasury/?profileId=ACoAAFMSUywBjPfTJvnYDWoHWLidpl3FpPJS8Cg&lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base%3BfYF6vxmUQ4ysaFh%2Bk6jA0w%3D%3D",
  },
  {
    id: 2,
    title: "Hult Prize National",
    issuer: "Hult Prize Foundation",
    year: "2026",
    image: "/assets/certificates/hultprize_national.jpg",
  },
];
